import { Component, type ReactNode } from "react";

interface Props {
  children: ReactNode;
}
interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error): void {
    if (import.meta.env.DEV) console.error("[ErrorBoundary]", error);
  }

  render(): ReactNode {
    if (this.state.error) {
      return (
        <div className="mx-auto max-w-xl p-8 text-center" role="alert">
          <h1 className="text-2xl font-semibold text-red-600">Er ging iets mis</h1>
          <p className="mt-2 text-gray-600">
            Probeer de pagina opnieuw te laden. Blijft de fout? Open een issue in deze
            repo met label <code>frontend-bug</code>.
          </p>
          <button
            type="button"
            onClick={() => this.setState({ error: null })}
            className="mt-6 rounded border border-gray-300 px-4 py-2 hover:bg-gray-100"
          >
            Probeer opnieuw
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
